export const nToPx = (...args: Array<string | number>): string => {
  if (args.length === 0 || args.length > 4) {
    throw new Error('Input non valido');
  }

  const pxValues = args.map((val) => {
    if (typeof val === 'string') {
      return val;
    }
    return `${val}px`;
  });
  return pxValues.join(' ');
};
